<script>
	import {onMount, onDestroy, createEventDispatcher} from 'svelte'
	import CropperJS from 'cropperjs'

	const dispatchEvent = createEventDispatcher()

	// Local cache
	let img, wrapper, cropper, saved, element

	// Public API
	export let src
	export let aspect_ratio
	export let flipped = false

	$: cropper && cropper.scaleX(flipped ? -1 : 1)
	$: cropper && cropper.setAspectRatio(aspect_ratio)

	const options = {
		viewMode: 1, // https://github.com/fengyuanchen/cropperjs/blob/master/README.md#viewmode
		aspectRatio: aspect_ratio,
		zoomable: false,
		checkCrossOrigin: false,
		checkOrientation: false,
		guides: false,
		highlight: false,
		autoCrop: true,
		autoCropArea: 0.96,
		crop(event) {
			const image = cropper.getImageData()

			// save state for when resize happes
			saved = event.detail

			// let upstream know a crop happened
			dispatchEvent('crop', {
				crop: event.detail,
				preview_image: cropper
					.getCroppedCanvas({
						width: 200,
						height: 200,
						imageSmoothingEnabled: false,
						imageSmoothingQuality: 'low',
					})
					.toDataURL(),
				crop_percentages: {
					offset_x: ((event.detail.x / image.naturalWidth) * 100).toFixed(2),
					offset_y: ((event.detail.y / image.naturalHeight) * 100).toFixed(2),
					width: ((event.detail.width / image.naturalWidth) * 100).toFixed(2),
					height: ((event.detail.height / image.naturalHeight) * 100).toFixed(
						2,
					),
				},
			})
		},
		ready() {
			// Append the <slot /> of this component into the cropper
			// Hacky, but does the job.
			wrapper.querySelector('.cropper-crop-box').appendChild(element)
		},
	}

	function resetCropper() {
		cropper.destroy()
		cropper = new CropperJS(img, {...options, data: saved})
	}

	onMount(() => {
		// Delay setting the cropper, because otherwise it'll render the cropper 3-4 times taller than needed
		setTimeout(function () {
			cropper = new CropperJS(img, options)
		}, 200)
		window.addEventListener('resize', resetCropper)
	})

	onDestroy(() => {
		cropper.destroy()
		window.removeEventListener('resize', resetCropper)
	})
</script>

<svelte:head>
	<link
		rel="stylesheet"
		href="https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.9/cropper.min.css"
	/>
</svelte:head>

<div bind:this={wrapper}>
	<img bind:this={img} {src} alt="Cropper preview" />
	<div bind:this={element}>
		<slot />
	</div>
</div>

<style>
	img {
		display: block;
		width: 100%;
	}

	:global(.cropper-view-box) {
		outline-color: #00b67a !important;
	}

	:global(.cropper-line) {
		background-color: #00b67a !important;
	}

	:global(.cropper-point) {
		background-color: #00b67a !important;
	}
</style>
